// recon-helpers-messages (es catalog).
window.PlummeI18n.register('es', {
  'rcx.loan.class.accruedInterest': 'Intereses devengados',
  'rcx.loan.class.unbookedPrincipal': 'Amortización no contabilizada',
  'rcx.loan.class.unbookedFee': 'Comisión no contabilizada',
  'rcx.loan.class.timing': 'Diferencia temporal',
  'rcx.loan.class.fxDifference': 'Diferencia de cambio',
  'rcx.loan.class.wrongLedger': 'Cuenta de mayor incorrecta',
  'rcx.loan.class.wrongTerm': 'Clasificación incorrecta a corto/largo plazo',
  'rcx.loan.class.missingDocs': 'Documentación faltante',
  'rcx.loan.class.other': 'Otro',
});
